<script setup lang="ts">
import { computed } from 'vue';
import Format from '@/lib/trashsim/format';

const props = withDefaults(defineProps<{
    modelValue: any,
    label: string,
    result?: any,
    booster?: Booster,
    type?: string,
    value?: any,
    values?: any[] | Object,
    trueValue?: any,
    falseValue?: any,
    noneValue?: any,
    suffix?: string
}>(), {
    result: null,
    type: 'number',
    trueValue: true,
    falseValue: false
})

const emits = defineEmits<{
    (e: 'update:modelValue', value: any): void
    (e: 'submit'): void
}>()

type Booster = {
    weapon: number
    shield: number
    armor: number
    cargo?: number
    speed?: number
    fuel?: number
}

const model = computed({
    get: () => props.modelValue,
    set: (value: any) => emits('update:modelValue', value)
})

const submit = () => emits('submit')
const hasBooster = computed(() => {
    return props.booster !== undefined && (
        props.booster.weapon +
        props.booster.shield +
        props.booster.armor +
        (props.booster.cargo || 0) +
        (props.booster.speed || 0) +
        (props.booster.fuel || 0)
    ) > 0
})
const boosterText = () => {
    let result = "<b>Lifeforms bonsuses:</b>\n"

    if (!props.booster) {
        return ""
    }
    if (!hasBooster) {
        return ""
    }

    let keys: (keyof typeof props.booster)[] = ['weapon', 'shield', 'armor', 'cargo', 'speed', 'fuel']
    for (const key of keys) {
        if (props.booster[key] === undefined || props.booster[key] == 0) {
            continue
        }
        result += `<b>${key}:</b> ${Format.Percent(props.booster[key] || 0, '-', 2)}\n`
    }

    return result
}

</script>

<template>
    <label>
        <span
            class="label-text"
            v-tooltip.top="{
                value: boosterText(),
                disabled: !hasBooster,
                escape: false
            }"
        >
            {{ label }}
            <span v-if="hasBooster" class="label-booster">*</span>
        </span>
        <span
            v-if="result != null"
            class="entity-remaining"
        >{{ Format.Number(result, '0')}} ← </span>
        <input
            v-if="type == 'number'"
            min="0"
            v-model="model"
            type="number"
            @keyup.enter="submit()"
        />
        <input type="text"
            v-if="type == 'text'"
            v-model="model"
            @keyup.enter="submit()"
        />
        <input
            v-else-if="type == 'checkbox'"
            v-model="model"
            type="checkbox"
            :true-value="trueValue"
            :false-value="falseValue"
        />
        <input
            v-else-if="type == 'radio'"
            type="radio"
            v-model="model"
            :value="value == model && noneValue ? noneValue : value"
        />
        <select
            v-else-if="type == 'select'"
            v-model="model"
        >
            <option v-for="value in values" :value="value">
                {{ value }}{{ suffix }}
            </option>
        </select>
    </label>
</template>

<style scoped>
input[type="text"] {
    width: 21% !important;
}
</style>

<style>
.p-tooltip {
    background-color: #506784;
    border-radius: 3px;
    padding: 5px;
}
</style>